/* Masso Diesel - tarjetas de producto estilo "Remanufactured / Core deposit".
   Funciona sobre las tarjetas de Boost y del tema: lee /products/<handle>.js y agrega
   logo de marca, etiqueta, marca, tipo, precio grande, casco (core) y total con casco. */
(function () {
  var cache = {};
  /* Logos de marca (assets del tema, junto a este archivo) */
  var SRC = (document.currentScript && document.currentScript.src) || '';
  function asset(name) { return SRC ? SRC.replace(/md-cards\.js(\?.*)?$/, name) : ''; }
  var LOGOS = { 'BOSCH': 'brand-bosch.svg', 'DENSO': 'brand-denso.svg', 'CONTINENTAL': 'brand-continental.svg',
    'ALLIANT POWER': 'brand-alliant.png', 'DELPHI': 'brand-delphi.png', 'STANADYNE': 'brand-stanadyne.png',
    'CALIFORNIA DIESEL': 'brand-california.png', 'HUSKY DIESEL INJECTION': 'brand-husky.png' };
  var ROUND = { 'CALIFORNIA DIESEL': 1 };
  var MAKES = { 'FORD': 'Ford', 'NAVISTAR': 'Navistar', 'CUMMINS': 'Cummins', 'CATERPILLAR': 'Caterpillar', 'CAT': 'Caterpillar',
    'DIESEL DETROIT': 'Detroit', 'ISUZU': 'Isuzu', 'NISSAN': 'Nissan', 'MITSUBISHI': 'Mitsubishi', 'VW': 'Volkswagen',
    'VOLKSWAGEN': 'Volkswagen', 'MERCEDES BENZ': 'Mercedes-Benz', 'JOHN DEERE': 'John Deere', 'NEW HOLLAND': 'New Holland',
    'CHEVROLET': 'Chevrolet', 'GMC': 'GMC', 'HINO': 'Hino', 'FIAT': 'Fiat', 'JAC': 'JAC', 'MAN': 'MAN', 'FREIGHTLINER': 'Freightliner',
    'DETROIT': 'Detroit', 'DODGE': 'Dodge', 'RAM': 'RAM', 'CHRYSLER': 'Chrysler', 'JEEP': 'Jeep', 'TOYOTA': 'Toyota', 'HONDA': 'Honda',
    'VOLVO': 'Volvo', 'VOLVO PENTA': 'Volvo Penta', 'SCANIA': 'Scania', 'KENWORTH': 'Kenworth', 'PACCAR': 'Paccar',
    'INTERNATIONAL': 'International', 'NAVISTAR/FORD': 'Ford / Navistar', 'DURAMAX': 'Duramax', 'GENERAL MOTORS': 'General Motors',
    'KOMATSU': 'Komatsu', 'CASE IH': 'Case IH', 'AUDI': 'Audi', 'BMW': 'BMW', 'PEUGEOT': 'Peugeot', 'LINCOLN': 'Lincoln',
    'LAND ROVER': 'Land Rover', 'JAGUAR': 'Jaguar', 'FERRARI': 'Ferrari', 'MERCEDES': 'Mercedes-Benz', 'YAMAHA': 'Yamaha' };
  var THIRD = ['BOSCH', 'DENSO', 'DELPHI', 'ALLIANT POWER', 'CALIFORNIA DIESEL', 'CONTINENTAL', 'STANADYNE', 'MAGNETI MARELLI',
    'STANDAR MOTOR PRODUCTS', 'OMRON', 'VISHAY', 'DREXEL INTERNATIONAL', 'HUSKY DIESEL INJECTION', 'WABASH'];
  var KINDS = [[/sensor.*turbo|turbo.*sensor|velocidad para turbo/i, 'Sensor de turbo'], [/sensor|map$|^map|tps|cig|levas|temperatura|velocidad|pedal|acelerador|posici/i, 'Sensor'],
    [/solenoide/i, 'Solenoide'], [/tobera/i, 'Tobera'], [/ligas/i, 'Ligas para inyector'], [/turbo/i, 'Turbo'], [/v[aá]lvula|egr/i, 'Válvula'],
    [/relay/i, 'Relay'], [/swicht|switch|neutral|reversa|lock/i, 'Interruptor'], [/bomba/i, 'Bomba']];

  function nice(s) { s = (s || '').trim(); var u = s.toUpperCase(); if (MAKES[u]) return MAKES[u];
    return s.toLowerCase().replace(/(^|[\s\-\/])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function money(cents) { var v = (cents / 100).toFixed(2).split('.'); return '$' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1]; }
  function bigMoney(cents) { var v = (cents / 100).toFixed(2).split('.');
    return '<sup>$</sup>' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '<sup>' + v[1] + '</sup>'; }
  function hasTag(p, t) { t = t.toUpperCase(); return (p.tags || []).some(function (x) { return x.toUpperCase() === t; }); }

  function describe(p) {
    var vendor = (p.vendor || '').toUpperCase();
    var type = p.type || '';
    var isPump = hasTag(p, 'BOMBA') || /^bomba/i.test(type);
    var part = /^\W*(bobina|solenoide|tobera|ligas|kit|sensor)/i.test(p.title) || /ligas|solenoide|tobera/i.test(type);
    var isInj = !isPump && !part && /inyector|heui|^eui|common rail/i.test(type);
    var reman = /reconstruido|reman/i.test(type + ' ' + p.title) || hasTag(p, 'Reman') || hasTag(p, 'Bosch Reman');
    var third = THIRD.indexOf(vendor) >= 0;
    var masso = !third && (!isPump || /^MASSO/.test(vendor));   /* marca propia: Masso Diesel (el vendor es la marca del vehiculo) */
    var badge = hasTag(p, 'Nuevo Bosch') ? 'Nuevo Bosch' : hasTag(p, 'Bosch Reman') ? 'Bosch Reman'
      : (masso && isInj && reman) ? 'Reconstruido' : reman ? 'Reman' : 'Nuevo';
    var make = '';
    if (masso && MAKES[vendor]) make = MAKES[vendor];
    if (!make) { for (var i = 0; i < (p.tags || []).length; i++) { var u = p.tags[i].toUpperCase(); if (MAKES[u] && u !== vendor) { make = MAKES[u]; break; } } }
    var kind = '';
    if (isPump) kind = /v[aá]lvula/i.test(type + ' ' + p.title) ? 'Válvula' : 'Bomba';
    else if (isInj) kind = reman ? 'Inyector Reman' : 'Inyector Nuevo';
    else if (/^\W*bobina/i.test(p.title)) kind = 'Bobina de inyector';
    else if (/golf/i.test(type)) kind = 'Carrito de golf';
    else { for (var k = 0; k < KINDS.length; k++) if (KINDS[k][0].test(type)) { kind = KINDS[k][1]; break; }
      if (!kind) kind = /^[A-Z\s]+$/.test(type) ? nice(type) : (type || 'Refacción'); }
    var base = p.variants[0], core = 0;
    p.variants.forEach(function (v) { if (v.price < base.price) base = v; });
    p.variants.forEach(function (v) { if (/sin casco/i.test(v.title || '')) core = v.price - base.price; });
    /* Stock: la linea "Disponibilidad" de la descripcion (Traxxion) o el inventario de Shopify */
    var txt = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
    var m = txt.match(/Disponibilidad:\s*([^.]+)\.\s*Entrega en\s*([^.]+?)\./i);
    var stock;
    if (m) stock = { ok: !/pedido/i.test(m[1]), text: /pedido/i.test(m[1]) ? 'Sobre pedido' : 'En existencia', when: 'Entrega ' + m[2].trim() };
    else if (p.available) stock = { ok: true, text: 'En existencia', when: 'Envío inmediato' };
    else stock = { ok: false, text: 'Sobre pedido', when: 'Entrega 5–7 días hábiles' };
    return { stock: stock, badge: badge, masso: masso, brand: masso ? 'Masso Diesel' : nice(p.vendor), kind: kind, make: make,
      price: base.price, core: core, logo: masso ? null : nice(p.vendor),
      logoImg: masso ? null : (LOGOS[vendor] ? asset(LOGOS[vendor]) : null), round: !!ROUND[vendor] };
  }

  function render(card, d) {
    if (card.getAttribute('data-md') === '1') return; card.setAttribute('data-md', '1');
    card.classList.add('md-card');
    var media = card.querySelector('.card-media, .card-product__media, [class*="image-wrapper"], [class*="product-image"], .boost-sd__product-image') || card;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    var mark = document.createElement('div'); mark.className = 'md-mark';
    if (d.masso) mark.innerHTML = '<img src="' + (window.MD_LOGO || '') + '" alt="Masso Diesel">';
    else if (d.logoImg) { mark.classList.add(d.round ? 'md-mark--round' : 'md-mark--brand');
      mark.innerHTML = '<img src="' + d.logoImg + '" alt="' + d.logo + '">'; }
    else mark.innerHTML = '<span class="md-bar"></span>' + d.logo;
    media.appendChild(mark);
    var title = card.querySelector('.card-title, .boost-sd__product-title, [class*="product-title"], h3 a, h3, .card-information a[href*="/products/"]');
    var badge = document.createElement('div'); badge.className = 'md-badge-wrap'; badge.innerHTML = '<span class="md-badge">' + d.badge + '</span>';
    var info = document.createElement('div'); info.className = 'md-info';
    var html = '<div class="md-brand">' + d.brand + '</div><div class="md-kind">' + d.kind + (d.make ? ' · ' + d.make : '') + '</div>'
      + '<div class="md-price">' + bigMoney(d.price) + '</div>';
    if (d.core > 0) html += '<div class="md-core">+' + money(d.core) + ' Casco (core)</div>'
      + '<div class="md-total">Precio total con casco: ' + money(d.price + d.core) + '</div>';
    else html += '<div class="md-core md-empty">&nbsp;</div><div class="md-total md-empty">&nbsp;</div>';
    info.innerHTML = html;
    var host = title ? (title.closest('h3, .card-title, .boost-sd__product-title, [class*="product-title"]') || title) : null;
    if (host && host.parentNode) { host.parentNode.insertBefore(badge, host); host.parentNode.insertBefore(info, host.nextSibling); }
    else { card.appendChild(badge); card.appendChild(info); }
    var st = document.createElement('div'); st.className = 'md-stock ' + (d.stock.ok ? 'md-stock--ok' : 'md-stock--order');
    st.innerHTML = '<div class="md-stock__state"><span class="md-stock__dot"></span>' + d.stock.text + '</div><div class="md-stock__when">' + d.stock.when + '</div>';
    var foot = card.querySelector('.card-information') || card.querySelector('.boost-sd__product-info') || card;
    foot.appendChild(st);
  }

  function handleOf(card) { var a = card.querySelector('a[href*="/products/"]'); if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  function get(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[handle];
  }

  /* Encabezado de coleccion: "Inyectores" + "Mostrando 1–24 de 118 resultados" */
  function header() {
    if (!/\/collections\//.test(location.pathname)) return;
    var bar = document.querySelector('.boost-sd__toolbar, toolbar-item.toolbar, .toolbar');
    if (!bar || !bar.parentNode) return;
    var head = document.querySelector('.md-head');
    if (!head) { head = document.createElement('div'); head.className = 'md-head';
      head.innerHTML = '<h1 class="md-head__title"></h1><p class="md-head__count"></p>'; bar.parentNode.insertBefore(head, bar); }
    var t = (document.querySelector('meta[property="og:title"]') || {}).content || document.title.split(/\s[–|-]\s/)[0];
    function set(sel, txt) { var el = head.querySelector(sel); if (el.textContent !== txt) el.textContent = txt; }
    set('.md-head__title', t);
    var shown = document.querySelectorAll('.md-card').length;
    var rc = document.querySelector('.boost-sd__product-count, .results-count, [class*="results-count"]');
    var total = rc ? parseInt((rc.textContent.match(/(\d[\d,]*)\s*(results|resultados|productos|products)/i) || [])[1] || '0', 10) : 0;
    if (!total || total < shown) total = shown;
    set('.md-head__count', shown ? 'Mostrando 1–' + shown + ' de ' + total + ' resultados' : '');
  }

  function scan() {
    try { header(); } catch (e) {}
    var cards = document.querySelectorAll('.boost-sd__product-item, .product-item, .product-card, .card-product');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var anc = c.parentElement && c.parentElement.closest('[data-md], [data-md-pending]');
      if (c.getAttribute('data-md') || c.getAttribute('data-md-pending') || anc) continue;
      var h = handleOf(c); if (!h) continue;
      c.setAttribute('data-md-pending', '1');
      (function (card, handle) { get(handle).then(function (p) { card.removeAttribute('data-md-pending'); if (p && p.variants && p.variants.length) render(card, describe(p)); }); })(c, h);
    }
  }
  var t; var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); });
  document.addEventListener('DOMContentLoaded', function () { scan(); obs.observe(document.body, { childList: true, subtree: true }); });
  if (document.readyState !== 'loading') { scan(); obs.observe(document.body, { childList: true, subtree: true }); }
})();
